import dayjs from 'dayjs';
import SideSheet from '..';
import { TransactionDetailsProps } from '../../../types';
import './PiggyPointDetails.scss';
import { copyToClipboard, formatToNaira } from '../../../helpers/utils';
import { MdContentCopy } from 'react-icons/md';

const PiggypointDetails = ({ onClose = () => {}, show, data }: TransactionDetailsProps) => {
  const close = () => {
    onClose();
  };

  return (
    <div>
      <SideSheet onClose={close} active={show} title="Piggypoint Details">
        <div className="piggypoint-details flex--4">
          <div className="piggypoint-details__hero">
            <h1>
              {data['arp_value']} {`point${data['arp_value'] !== 1 ? 's' : ''}`}
            </h1>
          </div>

          <div className="details flex--2">
            {Object.entries(data).map(([key, value]) => {
              let val: any = value;
              if (key === 'arp_date') {
                key = 'Date';
                val = dayjs(Number(value) * 1000).format('D MMM YYYY | h:mm A');
              }

              if (key === 'arp_own' || key === 'arp_type' || key === 'arp_value') {
                return;
              }

              if (key === 'arp_value') {
                key = 'Points';
                val = String(value);
              }

              if (key === 'arp_balance') {
                key = 'Balance';
                val = formatToNaira(value as number);
              }

              if (key === 'arp_id' || key === 'arp_ref') {
                return (
                  <div key={key} className="label-cont flex--4">
                    <label>{key === 'arp_id' ? 'Piggypoint Id' : key === 'arp_ref' ? 'Reference' : key}</label>
                    <div
                      className="copy flex--2"
                      onClick={() => copyToClipboard(key, typeof value === 'string' ? value : String(value))}
                    >
                      <p>{value ? String(val) : '-----'}</p>
                      {String(val) && <MdContentCopy className="pointer" />}
                    </div>
                  </div>
                );
              }
              return (
                <div key={key} className="label-cont flex--4">
                  <label>
                    {key === 'arp_id'
                      ? 'Piggypoint Id'
                      : key === 'arp_memo'
                        ? 'Description'
                        : key === 'arp_plan'
                          ? 'Plan'
                          : key}
                  </label>
                  <p>{val !== '' ? val : '-----'}</p>
                </div>
              );
            })}
          </div>
        </div>
      </SideSheet>
    </div>
  );
};

export default PiggypointDetails;
